// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ManageUser.css */

/* ======================================================= */
/* 💻 DESKTOP LAYOUT (Default Styles) */
/* ======================================================= */

.user-dashboard-container {
    padding: 20px;
    font-family: Arial, sans-serif;
}

.user-dashboard-container h1 {
    /* Large margins for desktop title centering */
    color: white;
    font-size: 1.5rem;
    text-align: center;
    margin: 40px 250px;
    font-family: 'GlitchGoblin', sans-serif;
    font-weight: 600;
}

h3 {
    margin-bottom: 25px;
}

/* --- Table Structure --- */

.table-wrapper {
    /* Keeps the table scrollable horizontally on smaller screens */
    overflow-x: auto; 
}

table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px; /* Optional: ensures minimum table width on large screens */
}

th, td {
    border: 1px solid #ddd;
    padding: 12px 15px;
    text-align: left;
    vertical-align: middle;
}

thead th {
    background-color: #424242;
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 0.9em;
}

tbody tr:nth-child(even) {
    background-color: #f9f9f9; 
}

tbody tr:hover {
    background-color: #f0f0f0; 
}

/* --- Dropdown & Status Styles (Always visible) --- */

.type-select {
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #ccc;
    cursor: pointer;
    font-weight: 500;
    /* Ensure dropdown fits nicely */
    min-width: 100px; 
}

.type-customer {
    color: #007bff; 
}

.type-reseller {
    color: #28a745; 
}

.status-pill {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.85em;
    font-weight: bold;
    text-align: center;
    min-width: 70px;
}

.status-active {
    background-color: #e6ffed;
    color: #00a049;
}

.status-pending {
    background-color: #fff3cd;
    color: #856404;
}

.status-suspended {
    background-color: #f8d7da;
    color: #721c24;
}

.global-status {
    padding: 10px;
    margin-bottom: 20px;
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
    border-radius: 4px;
    font-weight: bold;
    transition: opacity 0.3s ease-out;
}


/* ======================================================= */
/* 📱 MOBILE LAYOUT (Applied below 768px) */
/* ======================================================= */

@media screen and (max-width: 768px) {
    
    /* 1. Container Padding Adjustment */
    .user-dashboard-container {
        padding: 10px; /* Less padding on small screens */
    }

    /* 2. Title and Header Adjustment */
    .user-dashboard-container h1 {
        /* Remove large margins, use full width, slightly smaller font */
        margin: 20px 0;
        font-size: 1.3rem;
        text-align: center;
    }
    
    h3 {
        /* Ensure H3 is easily readable */
        font-size: 1.2rem;
        margin-bottom: 15px;
    }
    
    /* 3. Table Cell Condensing */
    th, td {
        padding: 8px 10px; /* Reduce cell padding */
        font-size: 0.9em; /* Slightly smaller font for table data */
    }
    
    thead th {
        font-size: 0.8em;
    }
    
    /* 4. Dropdown Size Optimization */
    .type-select {
        padding: 4px;
        font-size: 0.85em;
        min-width: 80px; /* Ensure it doesn't take up too much space */
    }

    /* 5. Status Pill Adjustment */
    .status-pill {
        padding: 3px 6px;
        font-size: 0.75em;
        min-width: 60px;
    }
}


/* ======================================================= */
/* 📱 MOBILE 'CARD' LAYOUT (Optional but Recommended) */
/* This is a more drastic change for better usability on phone screens.
   It requires changes to your React component's rendering logic (adding data-labels)
   and is thus kept commented out, as the default scrolling table is safer. 
/* ======================================================= */

/* @media screen and (max-width: 600px) {
    table, thead, tbody, th, td, tr { 
        display: block; 
    }
    
    thead tr { 
        position: absolute;
        top: -9999px;
        left: -9999px;
    }
    
    tr { 
        border: 1px solid #ccc;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    
    td {
        border: none;
        position: relative;
        padding-left: 50%;
        text-align: right;
    }
    
    td:before { 
        content: attr(data-label);
        position: absolute;
        left: 6px;
        width: 45%; 
        padding-right: 10px; 
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
}
*/`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ManageUser.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,4DAA4D;AAC5D,uCAAuC;AACvC,4DAA4D;;AAE5D;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,8CAA8C;IAC9C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4BAA4B;;AAE5B;IACI,+DAA+D;IAC/D,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB,EAAE,2DAA2D;AACjF;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sDAAsD;;AAEtD;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;AACrC;;;AAGA,4DAA4D;AAC5D,2CAA2C;AAC3C,4DAA4D;;AAE5D;;IAEI,oCAAoC;IACpC;QACI,aAAa,EAAE,kCAAkC;IACrD;;IAEA,mCAAmC;IACnC;QACI,gEAAgE;QAChE,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iCAAiC;QACjC,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA,6BAA6B;IAC7B;QACI,iBAAiB,EAAE,wBAAwB;QAC3C,gBAAgB,EAAE,yCAAyC;IAC/D;;IAEA;QACI,gBAAgB;IACpB;;IAEA,kCAAkC;IAClC;QACI,YAAY;QACZ,iBAAiB;QACjB,eAAe,EAAE,6CAA6C;IAClE;;IAEA,8BAA8B;IAC9B;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;AACJ;;;AAGA,4DAA4D;AAC5D,uDAAuD;AACvD;;;4DAG4D;;AAE5D;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAuCC","sourcesContent":["/* ManageUser.css */\n\n/* ======================================================= */\n/* 💻 DESKTOP LAYOUT (Default Styles) */\n/* ======================================================= */\n\n.user-dashboard-container {\n    padding: 20px;\n    font-family: Arial, sans-serif;\n}\n\n.user-dashboard-container h1 {\n    /* Large margins for desktop title centering */\n    color: white;\n    font-size: 1.5rem;\n    text-align: center;\n    margin: 40px 250px;\n    font-family: 'GlitchGoblin', sans-serif;\n    font-weight: 600;\n}\n\nh3 {\n    margin-bottom: 25px;\n}\n\n/* --- Table Structure --- */\n\n.table-wrapper {\n    /* Keeps the table scrollable horizontally on smaller screens */\n    overflow-x: auto; \n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 600px; /* Optional: ensures minimum table width on large screens */\n}\n\nth, td {\n    border: 1px solid #ddd;\n    padding: 12px 15px;\n    text-align: left;\n    vertical-align: middle;\n}\n\nthead th {\n    background-color: #424242;\n    color: white;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 0.9em;\n}\n\ntbody tr:nth-child(even) {\n    background-color: #f9f9f9; \n}\n\ntbody tr:hover {\n    background-color: #f0f0f0; \n}\n\n/* --- Dropdown & Status Styles (Always visible) --- */\n\n.type-select {\n    padding: 6px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    cursor: pointer;\n    font-weight: 500;\n    /* Ensure dropdown fits nicely */\n    min-width: 100px; \n}\n\n.type-customer {\n    color: #007bff; \n}\n\n.type-reseller {\n    color: #28a745; \n}\n\n.status-pill {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 0.85em;\n    font-weight: bold;\n    text-align: center;\n    min-width: 70px;\n}\n\n.status-active {\n    background-color: #e6ffed;\n    color: #00a049;\n}\n\n.status-pending {\n    background-color: #fff3cd;\n    color: #856404;\n}\n\n.status-suspended {\n    background-color: #f8d7da;\n    color: #721c24;\n}\n\n.global-status {\n    padding: 10px;\n    margin-bottom: 20px;\n    background-color: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n    border-radius: 4px;\n    font-weight: bold;\n    transition: opacity 0.3s ease-out;\n}\n\n\n/* ======================================================= */\n/* 📱 MOBILE LAYOUT (Applied below 768px) */\n/* ======================================================= */\n\n@media screen and (max-width: 768px) {\n    \n    /* 1. Container Padding Adjustment */\n    .user-dashboard-container {\n        padding: 10px; /* Less padding on small screens */\n    }\n\n    /* 2. Title and Header Adjustment */\n    .user-dashboard-container h1 {\n        /* Remove large margins, use full width, slightly smaller font */\n        margin: 20px 0;\n        font-size: 1.3rem;\n        text-align: center;\n    }\n    \n    h3 {\n        /* Ensure H3 is easily readable */\n        font-size: 1.2rem;\n        margin-bottom: 15px;\n    }\n    \n    /* 3. Table Cell Condensing */\n    th, td {\n        padding: 8px 10px; /* Reduce cell padding */\n        font-size: 0.9em; /* Slightly smaller font for table data */\n    }\n    \n    thead th {\n        font-size: 0.8em;\n    }\n    \n    /* 4. Dropdown Size Optimization */\n    .type-select {\n        padding: 4px;\n        font-size: 0.85em;\n        min-width: 80px; /* Ensure it doesn't take up too much space */\n    }\n\n    /* 5. Status Pill Adjustment */\n    .status-pill {\n        padding: 3px 6px;\n        font-size: 0.75em;\n        min-width: 60px;\n    }\n}\n\n\n/* ======================================================= */\n/* 📱 MOBILE 'CARD' LAYOUT (Optional but Recommended) */\n/* This is a more drastic change for better usability on phone screens.\n   It requires changes to your React component's rendering logic (adding data-labels)\n   and is thus kept commented out, as the default scrolling table is safer. \n/* ======================================================= */\n\n/* @media screen and (max-width: 600px) {\n    table, thead, tbody, th, td, tr { \n        display: block; \n    }\n    \n    thead tr { \n        position: absolute;\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    tr { \n        border: 1px solid #ccc;\n        margin-bottom: 10px;\n        display: flex;\n        flex-direction: column;\n        padding: 10px;\n        border-radius: 8px;\n        box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n    }\n    \n    td {\n        border: none;\n        position: relative;\n        padding-left: 50%;\n        text-align: right;\n    }\n    \n    td:before { \n        content: attr(data-label);\n        position: absolute;\n        left: 6px;\n        width: 45%; \n        padding-right: 10px; \n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n}\n*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
